import { useAPICallAsync } from '@michelin/central-provider';
import { useMutation } from 'react-query';
import { rubyOrderRoute as baseRoute } from 'services/restApiConst';
import { OrderResponseType } from 'types/APIResponse';

export const useOrderActions = () => {
  // I dont like this any, but it is used on many components with many different payloads, so it is a TODO
  const { call } = useAPICallAsync<OrderResponseType, any>({
    api: {
      method: 'PUT',
      endpoint: `orders`,
    },
    baseRoute,
  });

  const mutation = useMutation((params: { payload: any; orderId: number }) => {
    return call(params.payload, params.orderId, true);
  });

  const { isLoading, data, error } = mutation;

  const mutate = async (params: any, orderId: number | string) => {
    const { data: order } = await mutation.mutateAsync({ payload: params, orderId: Number(orderId) });
    return { data: order };
  };

  return {
    ...data,
    error,
    loading: isLoading,
    callOrderAction: mutate,
  };
};
